/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ReceptionInputs */

const cs_enum_reception = /** @type {(inputs: Enum_ReceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recepce`)
};

const en_enum_reception = /** @type {(inputs: Enum_ReceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reception`)
};

/**
* | output |
* | --- |
* | "Reception" |
*
* @param {Enum_ReceptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reception = /** @type {((inputs?: Enum_ReceptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ReceptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reception(inputs)
	return cs_enum_reception(inputs)
});